import { render, staticRenderFns } from "./SolutionsDistribution.vue?vue&type=template&id=e0994558&scoped=true"
import script from "./SolutionsDistribution.js?vue&type=script&lang=js&external"
export * from "./SolutionsDistribution.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsDistribution.scss?vue&type=style&index=0&id=e0994558&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0994558",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
